import { gql } from '@apollo/client';

export const CREATE_PRICING_SCHEME_DOWNLOAD_TASK = gql`
  mutation CreatePricingSchemeDownloadTask(
    $format: String!
    $businessScenario: Long
    $clientId: Long
    $pricingSchemeId: Long
    $creatorName: String
    $createdAtStart: String
    $createdAtEnd: String
  ) {
    createPricingSchemeDownloadTask(
      format: $format
      businessScenario: $businessScenario
      clientId: $clientId
      pricingSchemeId: $pricingSchemeId
      creatorName: $creatorName
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
    ) {
      success
      message
      messageKey
      data
    }
  }
`;

export interface CreatePricingSchemeDownloadTaskResponse {
  createPricingSchemeDownloadTask: {
    success: boolean;
    message?: string | null;
    messageKey?: string | null;
    data?: string | null;
  };
}

export interface CreatePricingSchemeDownloadTaskVariables {
  format: 'csv' | 'excel' | 'json';
  businessScenario?: number;
  clientId?: number;
  pricingSchemeId?: number;
  creatorName?: string;
  createdAtStart?: string;
  createdAtEnd?: string;
}
